export default __webpack_public_path__ + "static/media/LoginBackground.b2e05505.png";